import { render, staticRenderFns } from "./TiptapMenuItem.vue?vue&type=template&id=e35f1d8e&scoped=true"
import script from "./TiptapMenuItem.vue?vue&type=script&lang=js"
export * from "./TiptapMenuItem.vue?vue&type=script&lang=js"
import style0 from "./TiptapMenuItem.vue?vue&type=style&index=0&id=e35f1d8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e35f1d8e",
  null
  
)

export default component.exports